import * as yup from 'yup';

export const languageValidation = yup.object({
  name: yup.string('Enter Name').required('Name is required'),
  direction: yup
    .string('Enter Direction')
    .required('Direction is required'),
});


